import Vue from "vue";
import store from "../store";
import { configure } from "vee-validate";

const CURRENT_LANG = store.getters["AppLangModule/getAppLocale"] || "ar";
import {
  ValidationObserver,
  ValidationProvider,
  extend,
  localize,
} from "vee-validate";

import en from "vee-validate/dist/locale/en.json";
import ar from "vee-validate/dist/locale/ar.json";
import * as rules from "vee-validate/dist/rules";

Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);

Object.keys(rules).forEach((rule) => {
  extend(rule, rules[rule]);
});

configure({
  bails: true, // stop at first validation error
  validateOnInput: true, // validate while typing
  validateOnBlur: true, // validate on blur
  validateOnChange: true, // validate when value changes
});

extend("decimal", {
  validate: (value, { decimals = "*", separator = "." } = {}) => {
    if (value === null || value === undefined || value === "") {
      return {
        valid: false,
      };
    }
    if (Number(decimals) === 0) {
      return {
        valid: /^-?\d*$/.test(value),
      };
    }
    const regexPart = decimals === "*" ? "+" : `{1,${decimals}}`;
    const regex = new RegExp(
      `^[-+]?\\d*(\\${separator}\\d${regexPart})?([eE]{1}[-]?\\d+)?$`
    );

    return {
      valid: regex.test(value),
    };
  },
});

extend("englishLettersAndNumbersOnly", {
  validate: (value) => {
    const regex = /^[a-zA-Z0-9\u0660-\u0669\p{P}\p{S}\s]+$/u;

    return {
      valid: regex.test(value),
    };
  },
});
extend("phone", {
  validate(value) {
    const isValid = /^[0-9]{8,15}$/.test(value);
    return isValid;
  },
});

extend("positive", {
  validate(value) {
    const isPositive = Number(value) > 0;
    return isPositive;
  },
});
extend("arabicLettersAndNumbersOnly", {
  validate: (value) => {
    const regex = /^[\u0621-\u064A\u0660-\u06690-9\p{P}\p{S}\s]+$/u;

    return {
      valid: regex.test(value),
    };
  },
});

extend("numbersOnly", {
  validate: (value) => {
    const regex = new RegExp(`^[0-9]{1,2}$`);

    return {
      valid: regex.test(value),
    };
  },
});

extend("15numbersOnly", {
  validate: (value) => {
    const regex = new RegExp(`^[0-9]{15}$|^[0-9]{9}$`);

    return {
      valid: regex.test(value),
    };
  },
});

extend("anyNumbersOnly", {
  validate: (value) => {
    const regex = new RegExp(`^[0-9]+$|^[\u0660-\u0669]+$`);

    return {
      valid: regex.test(value),
    };
  },
});

extend("positive", (value) => {
  return value >= 0;
});

extend("englishLettersOnly", {
  validate: (value) => {
    const regex = new RegExp(`^[a-zA-Z\\s]*$`);

    return {
      valid: regex.test(value),
    };
  },
  message: "Name must be English character",
});

extend("englishLettersOnlyNoSpace", {
  validate: (value) => {
    const regex = new RegExp(`^[A-Za-z]+$`);

    return {
      valid: regex.test(value),
    };
  },
});

extend("date_after", {
  params: ["target"],
  validate(value, { target }) {
    return new Date(value) > new Date(target);
  },
  message: (_, values) => `تاريخ النهاية يجب أن يكون بعد تاريخ البداية.`,
});

extend("number", {
  validate(value) {
    return /^[0-9]+$/.test(value);
  },
});

extend("custom_password", {
  validate(value) {
    const minLength = value.length >= 8;
    const hasUppercase = /[A-Z]/.test(value);
    const hasLowercase = /[a-z]/.test(value);
    const hasSymbol = /[!@#$%^&*(),.?":{}|<>]/.test(value);

    return minLength && hasUppercase && hasLowercase && hasSymbol;
  },

  message:
    "يجب أن تحتوي كلمة المرور على 8 أحرف على الأقل، وحرف كبير، ورمز خاص.",
});

extend("password_match", {
  params: ["target"],
  validate(value, { target }) {
    return value === target;
  },
});

extend("percentage", {
  validate(value) {
    return Number(value) >= 0 && Number(value) <= 100;
  },
});

extend("price_after_discount", {
  params: ["originalPrice"],
  validate(value, { originalPrice }) {
    if (!value || !originalPrice) return true; // Allow empty values
    return Number(value) <= Number(originalPrice);
  },
});

localize("ar", {
  ...ar,
  names: {
    price_after_tax: "السعر بعد الضريبة",
  },
  messages: {
    ...ar.messages,
    percentage: "النسبة يجب أن تكون بين 0% و 100%",
    password_match: "كلمة المرور وتأكيد كلمة المرور غير متطابقين.",
    custom_password:
      "يجب أن تحتوي كلمة المرور على 8 أحرف على الأقل، وحرف كبير،وحرف صغير, ورمز خاص.",
    price_after_discount:
      "السعر بعد الخصم يجب أن يكون أقل من أو يساوي السعر الأصلي",
    number: "{_field_} يجب ان يكون رقما",
    required: " {_field_} مطلوب",
    positive: "{_field_} يجب ان يكون رقما موجبا",

    date_after: "تاريخ النهاية يجب ان يكون لاحقا لتاريخ البداية",
    alpha: "هذا الحقل يجب ان يحتوي على حروف ابجدية فقط",
    decimal: "{_field_} يجب ان يحتوي على رقم صحيح او عشري",
    englishLettersOnly: "{_field_} يجب ان يحتوي على حروف انجليزية فقط ",
    email: "يجب أن يكون حقل البريد الإلكتروني بريدًا إلكترونيًا صالحًا",
    confirmed: "يجب مطابقة كلمة المرور",
    arabicLettersAndNumbersOnly: "..الأحرف مطلوبة بالعربية",
    englishLettersAndNumbersOnly: "الأحرف مطلوبة بالإنجليزية",
    date_after: "تاريخ النهاية يجب ان يكون لاحقا لتاريخ البداية",
    phone: "رقم الهاتف غير صالح. .",
    url: "رابط {_field_} غير صالح",
  },
});

localize("en", {
  ...en,
  names: {
    price_after_tax: "Price after tax",
  },
  messages: {
    ...en.messages,
    percentage: "percentage must be between 0% and 100%",
    custom_password:
      "The password must contain at least 8 characters, one uppercase letter,one lowercase letter, and one special symbol.",
    password_match: "The password and confirm password do not match.",
    price_after_discount:
      "Price after discount must be less than or equal to the original price",
    arabicLettersAndNumbersOnly: "Characters required in Arabic",
    englishLettersAndNumbersOnly: "Characters required in English",
    date_after: "The end date must be after the start date.",
    number: "{_field_} must be number",
    required: "{_field_} is required",
    alpha: "{_field_} may only contain alphabetic characters",
    decimal: "{_field_} must be a valid decimal",
    positive: "{_field_} must be positive number",

    englishLettersOnly: "{_field_} must contain only English letters",
    email: "{_field_} must be a valid email",
    confirmed: "Password confirmation does not match",
    url: "{_field_} isn't a valid url",

    phone: "Invalid phone number.",
  },
});

localize(CURRENT_LANG);

extend("url", {
  validate: (value) => {
    const regex = new RegExp(
      `http[s]?://(?:[a-zA-Z]|[0-9]|[$-_@.&+]|[!*\(\),]|(?:%[0-9a-fA-F][0-9a-fA-F]))+`
    );

    return {
      valid: regex.test(value),
    };
  },
});
